import { inject, Pipe, PipeTransform } from "@angular/core";
import { DirectusTranslationService } from "../../../../../../../common/i18n/directus-translation.service";
import { sanitizeDirectusArray } from "../../../../../../../common/utils/sanitize-directus-object";
import { Files } from "../../../../../../api/packbo/models/files";
import { ItemsProductCategories } from "../../../../../../api/packbo/models/items-product-categories";
import { ItemsSuppliers } from "../../../../../../api/packbo/models/items-suppliers";

type SupplierImageData = {
    src: string | Files;
    alt: string;
};

type DirectusTranslation = {
    languages_code?: string | null;
    title?: string | null;
    [key: string]: unknown;
};

@Pipe({
    name: "supplierImageData"
})
export class SupplierImageDataPipe implements PipeTransform {
    private readonly directusTranslationService = inject(DirectusTranslationService);

    public transform(
        supplier: ItemsSuppliers,
        category: ItemsProductCategories | null = null
    ): SupplierImageData | null {
        if (supplier.logo) {
            return {
                src: supplier.logo,
                alt: supplier.name || ""
            };
        }

        if (category?.image) {
            const sanitizedTranslations = sanitizeDirectusArray(category.translations_refs);
            const title = this.directusTranslationService.getTranslation(
                sanitizedTranslations as DirectusTranslation[],
                "title"
            );

            return {
                src: category.image,
                alt: title
            };
        }

        return null;
    }
}
